import React, { useEffect, useState } from 'react';

/**
 * GurgenclerIletisim2026: lansman dönemi (Eylül 2026) dört aşamalı iletişim kurgusu.
 * Route: /r/gurgencler-lansman-iletisim-2026 (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 31 slayt, 16:9, apple.com tasarım dili: beyaz zemin, gri yuvarlak kutucuklar,
 * kutu içinde renkli SVG görseller. Analiz sunumundan (/r/gurgencler-lansman-2026)
 * ayrı bir belge; rakamlar aynı deck-data.json çekiminden geliyor ki ikisi tutsun.
 * Yeniden üretmek için: node src/pages/gurgencler-iletisim/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 *
 * HTML modülü ~86KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function GurgenclerIletisim2026() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./gurgenclerIletisimHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Gürgençler · Lansman Dönemi 2026 İletişim Kurgusu"
      srcDoc={html}
      style={fill}
    />
  );
}
